import React, { useEffect, useState } from 'react'
import { Badge, Card, Col, Container, Dropdown, Modal, Row, Table } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { getSchool } from '../../actions/schoolsActions'
import SubMenuDatabase from '../../components/menus/SubMenuDatabase'
import CandidateProfile from '../admin/CandidateProfile'
import Swal from 'sweetalert2'
import { editStockWithCandidates, getStocksBySchool } from '../../actions/stocksActions'
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'
import { getTitles } from '../../actions/candidatesActions'

export default function BlockedDatabase() {
    const { t } = useTranslation()
	const {client} = useAuth()
    const dispatch = useDispatch()

    const {school} = useSelector(state=>state.schools)
    const {result, stocksWithCandidates, loading} = useSelector(state => state.stocks)
    const {titles} = useSelector(state=>state.candidates)

    const [selectedCandidate, setSelectedCandidate] = useState(null)
    
    const handleEditStock = (candidate, movement) => {
        let typeMovement = ''
        let typeStock = ''
        let swalText = ''

        if(movement === 'addFavourite'){
            typeMovement = 'add'
            typeStock = 'favourite'
            swalText = t('database.addFavouriteCandidateQuestion')
        }else if(movement === 'removeBlocked'){
            typeMovement = 'remove'
            typeStock = 'blocked'
            swalText = t('database.removeBlockCandidateQuestion')
        }

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.confirm'),
            denyButtonText: t('global.cancel'),
            icon: 'question',
            text: t(swalText, {name: `${candidate.firstname} ${candidate.lastname}`})
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(editStockWithCandidates(school?._id, candidate._id, typeStock, typeMovement))
            }
        })
    }

    useEffect(() => {
        if(client){
            dispatch(getSchool(client?.id))
        }
    },[dispatch, t, client])

    useEffect(() => {
        if(school){
            dispatch(getStocksBySchool(school._id))
            dispatch(getTitles())
        }
    },[school, dispatch])

    useEffect(() => {
        if(result){
            switch (result) {
                case 'successRemoveBlocked':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('database.successRemoveBlocked')
                    })
                    break;
                case 'successAddFavourite':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('database.successAddFavourite')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [result])

    return (
        <>
            <Container className='cuerpo'>
                <Row className="mb-5">
                    <Col className='d-flex align-items-center'>
                        <img src="/images/menus/database.svg" alt="Base de datos" />
                        <h1 className='ms-2 m-0'>{t('menus.database')}</h1>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <Card className='mb-5 sombra lateral'>
                            <Card.Body className='p-5'>
                                <SubMenuDatabase section="blocked"/>
                                <Row className='my-3'>
                                    <Col xs={10}>
                                        <h3 className='ms-2 m-0'>{t('database.submenu.blocked')} ({stocksWithCandidates.filter(stock => stock.typeStock.includes('blocked')).length})</h3>
                                    </Col>
                                </Row>
                                <Row className='my-3'>
                                    <Col className='my-3'>
                                        {
                                            loading
                                            ?
                                                <div className='text-center'>
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </div>
                                            :
                                                <Table>
                                                    <thead>
                                                        <tr>
                                                            <th>{t('school.selection.name')}</th>
                                                            <th>{t('profile.availability')}</th>
                                                            <th>{t('users.town')}</th>
                                                            <th>{t('profile.candidate.officialTitles')}</th>
                                                            <th className='bg-grey text-center' style={{width: '150px'}}>{t('global.actions')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            stocksWithCandidates?.filter(stock => stock?.typeStock?.includes('blocked'))?.map((stock, index) => (
                                                                <tr key={index}>
                                                                     <td className='d-flex align-items-center'>
                                                                        <div className='avatar-mini list cursor me-2' onClick={() => setSelectedCandidate(stock.user._id)}>
                                                                            <div className='img-profile' style={{backgroundImage: `url(${stock.user?.image ? stock.user.image : "/images/avatar-empty.svg"})`}}/>
                                                                        </div>
                                                                        { stock.candidate.firstname } { stock.candidate.lastname }
                                                                    </td>
                                                                    <td className='align-middle'>
                                                                        { stock.candidate.searching === true ? t('global.yes') : t('global.no') }
                                                                    </td>
                                                                    <td className='align-middle'>
                                                                        { `${stock.candidate.town ? `${towns.find(t => t.value === stock.candidate.town)?.label}${stock.candidate.province ? ` (${provinces.find(p => p.value === stock.candidate.province)?.label})` : ''}` : ''}` }
                                                                    </td>
                                                                    <td className='align-middle'>
                                                                        { stock?.candidate?.academic?.map((academic, academicIndex) => (
                                                                            <Badge key={academicIndex} className='bg-grey text-muted p-2 mx-1'>{titles?.find(t => t.id == academic.title) ? t('titles.' + titles?.find(t => t.id == academic.title).title) : academic.title}</Badge>
                                                                        )) }
                                                                    </td>
                                                                    <td className='bg-grey text-center'>
                                                                        <Dropdown drop='start'>
                                                                            <Dropdown.Toggle as="img" src="/images/options.svg" className='cursor'/>
                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item as="div" className='cursor' onClick={() => handleEditStock(stock?.candidate, 'removeBlocked')}>
                                                                                    {t("database.unblock")}
                                                                                </Dropdown.Item>
                                                                                <Dropdown.Item as="div" className='cursor' onClick={() => handleEditStock(stock?.candidate, 'addFavourite')}>
                                                                                    {t("database.addFavourite")}
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </Table>
                                        }
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Modal show={selectedCandidate ? true : false} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title" centered>
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title" className='w-100 d-flex justify-content-end'>
						<div>
							<i className='fa fa-times cursor' onClick={() => setSelectedCandidate(null)}></i>
						</div>
					</Modal.Title>
                </Modal.Header>
                <Modal.Body>
					<CandidateProfile candidateToShow={{iduser: selectedCandidate}}/>
                </Modal.Body>
            </Modal>
        </>
    )
}